import { OverrideCondition } from './enums/override-condition';

export class AttributeOverrideRow {
    public attributeId: number = null;
    public attributeName: string = null;
    public overrideCondition: OverrideCondition = null;
}
